module.exports = __webpack_public_path__ + "static/media/Assets-09-Capital-01.b0f29ae4.mp4";